import TestimonialCard from "./components/testimonial-card";
import SEO from '../../components/seo';

export default function Feedback(){
    return(
        <div className="min-h-screen bg-[#090909] py-12 text-zinc-300">
            <SEO
                title="Client Feedback | Quilaton Law Office"
                description="Read client feedback and share your experience with Quilaton Law Office in Cebu City."
                path="/feedback/"
            />
            <div>
                <TestimonialCard/>
            </div>
        </div>
    );
}
